export const UserExcelStrings = {
  exportType: "user",
  fileName: "User Details.xlsx",
  userDetails: "User Details",
};
export const ValueStrings = {
  DATE_FORMAT_SMALL: "dd/MM/yyyy",
  dateFormat: "DD/MM/YYYY",
  dateFormatMonth: "MM/DD/YYYY",
  installationDateFormat: "YYYY-MM-DD",
  DATE_TIME_FORMAT: "dd/MM/yyyy HH:mm",
  CIP_DATE_TIME_FORMAT: "YYYY-MM-DD HH:mm:ss",
  DATE_TIME_SECONDS_FORMAT: "dd/MM/yyyy HH:mm:ss",
  contactUsPageLink: "https://www.dupont.com/water/contact-us.html",
};
export const XlsNormalizefileKey = {
  date: "date",
  feedFlowrate: "feed_flowrate",
  concentrateFlowrate: "concentrate_flowrate",
  permeateFlow: "permeate_flowrate",
  feedPressure: "feed_pressure",
  concentratePressure: "concentrate_pressure",
  permeatePressure: "permeate_pressure",
  pressureDrop: "pressure_drop",
  feedQuality: "feed_quality",
  permeateConductivity: "permeate_quality",
  feedTemp: "feed_temp",
  failureProbability: "Failure Probability",
  normalizeSaltPassage: "norm_salt_passage",
  normalizePermeateFlow: "norm_permeate_flow",
  normalizeDPRack2: "norm_pressure_drop",
  // calculateFeedTDS: "calculated_feed_TDS",
  // permeateTDS: "permeate_TDS"
};

export const TagColorOptions = [
  {
    name: "Teal",
    code: "#128370",
  },
  {
    name: "Pink",
    code: "#FC2D72",
  },
  {
    name: "Orange",
    code: "#FF9E19",
  },
  {
    name: "Green",
    code: "#58B947",
  },
  {
    name: "Blue",
    code: "#00A9E0",
  },
  {
    name: "Purple",
    code: "#5F259F",
  },
  {
    name: "Light Pink",
    code: "#FFA3CA",
  },
  {
    name: "Dark Blue",
    code: "#004c97",
  },
  {
    name: "Light Orange",
    code: "#FFCD00",
  },
  {
    name: "Light Green",
    code: "#A4D65E",
  },
  {
    name: "Light Teal",
    code: "#6DD8CD",
  },
  {
    name: "Light Blue",
    code: "#8BDCF9",
  },
  {
    name: "Light Purple",
    code: "#AD87F7",
  },
  {
    name: "Vivid Purple",
    code: "#C900E3",
  },
  {
    name: "Brown",
    code: "#844700",
  },
];
